import React from 'react';

import { Segment, Message, Tab } from 'semantic-ui-react';

import useRecipe, { hasAnyRecipe } from 'components/modules/foundation/hooks/use-recipe';
import FaqsPageTab from 'components/modules/questions/components/FaqsPageTab';
import QuestionGroupsTab from 'components/modules/questions/components/QuestionGroupsTab';
import QuestionsTab from 'components/modules/questions/components/QuestionsTab';
import { QuestionsProvider, useQuestionsContext } from 'components/modules/questions/context';
import { FAQS_PAGE_RECIPES } from 'constants/recipes';

import './QuestionsPage.scss';

const propTypes = {};
const defaultProps = {};

function QuestionsPageContent() {
  const { loading, message, messageType, messageOperations } = useQuestionsContext();
  const { activePatch } = useRecipe();
  const showFaqsPageTab = hasAnyRecipe(activePatch, FAQS_PAGE_RECIPES);

  function createPane({ icon, content, Component }) {
    return {
      menuItem: {
        key: content,
        icon,
        content,
      },
      render: () => (
        <Tab.Pane key={content}>
          <Component />
        </Tab.Pane>
      ),
    };
  }

  const panes = [
    createPane({
      icon: 'question circle',
      content: 'Questions',
      Component: QuestionsTab,
    }),
    createPane({
      icon: 'tags',
      content: 'Question Groups',
      Component: QuestionGroupsTab,
    }),
  ];

  if (showFaqsPageTab) {
    panes.push(
      createPane({
        icon: 'help circle',
        content: 'FAQs Page',
        Component: FaqsPageTab,
      }),
    );
  }

  return (
    <div className="questions-page">
      <Segment vertical loading={loading}>
        {message && (
          <Message
            positive={messageType === 'success'}
            negative={messageType === 'error'}
            content={message}
            onDismiss={messageOperations.clearMessage}
          />
        )}

        <Tab
          className="questions-management-tabs"
          menu={{ secondary: true, pointing: true }}
          panes={panes}
        />
      </Segment>
    </div>
  );
}

export default function QuestionsPage() {
  return (
    <QuestionsProvider>
      <QuestionsPageContent />
    </QuestionsProvider>
  );
}

QuestionsPage.propTypes = propTypes;
QuestionsPage.defaultProps = defaultProps;
